import { render, staticRenderFns } from "./userleave.vue?vue&type=template&id=a6272b46&"
import script from "./userleave.vue?vue&type=script&lang=js&"
export * from "./userleave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports